module.exports = __webpack_public_path__ + "static/media/13-active.85a0bbac.png";